module.exports = __webpack_public_path__ + "img/web_1_wz.1c854bd4.png";